import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarListOpen: true,
  headerTitle: ['Dashboard'],
  sidebarNestedReports:false,
  sidebarNestedMaster:false,
  nestedSidebar: null
}

const navigateSlice = createSlice({
  name: 'navigate',
  initialState,
  reducers: {
    setSidebarListOpen: (state, action) => {
      state.sidebarListOpen = action.payload
    },
    setSidebarNestedReportListOpen: (state, action) => {
      state.sidebarNestedReports = action.payload
    },
    setSidebarNestedMasterListOpen: (state, action) => {
      state.sidebarNestedMaster = action.payload
    },
    setNestedSidebar: (state, action) => {
      state.nestedSidebar = action.payload
    },
    setHeaderTitle: (state, action) => {
      state.sidebarNestedMaster = action.payload
    },
  },
})

export const { setSidebarListOpen, setHeaderTitle, setSidebarNestedReportListOpen, setSidebarNestedMasterListOpen, setNestedSidebar } = navigateSlice.actions
export default navigateSlice.reducer
